import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/privacy-policy/page.tsx");
